import { Transition } from 'vue';
import { Loader } from '@/components/loader';
import clsx from 'clsx';
import { Routes } from '@/router/routes';
import { Button, ButtonTypes } from '@/components/button';
import { Icon, IconNames } from '@/components/icon';
import styles from './styles.module.scss';
import { DealTypeSelectorClass, IconMap } from './types';

// Here is an example of how can we keep templates/render function in a separated file
// Notes:
// It is required to describe the same types in the interface and in the class.
// We can't use private properties but barely it will be required.
// We can provide component class as type but it leads to cyclic dependency issue, works tho.

export function dealTypeSelectorItem(component: DealTypeSelectorClass, type: string, value: number | undefined): JSX.Element {
	const iconMap: IconMap = {
		lease: IconNames.key,
		loan: IconNames.calc,
		cash: IconNames.cash,
	};

	return (
		<div onClick={ () => component.handleTypeChange(type) } class={ clsx([
			styles.dealTypeSelectorItem,
			type === component.type && styles.dealTypeSelectorItemActive,
		]) }>
			<div class={ styles.dealTypeSelectorItemIcon }>
				<Icon name={ iconMap[type] } />
			</div>
			<div class={ styles.dealTypeSelectorItemTitle }>
				{ component.i18n.t(`dealTypeSelector.${type}`) }
			</div>
			<div class={ styles.dealTypeSelectorItemValue }>
				{ component.getValueString(type, value) }
			</div>
			<Button iconFirst={ false } type={ ButtonTypes.link } inverted={ true } to={ Routes.DEAL_DETAILS.path }
				class={ styles.dealTypeSelectorItemDetails }
				onClick={ () => component.onDetailsClick(type) }
				v-slots={ { icon: () => <Icon name={ IconNames.info } size={ 18 } /> } }>
				<span class={ styles.dealTypeSelectorDetailsText }>
					{ component.i18n.t(`dealTypeSelector.${type}Details`) }
				</span>
			</Button>
		</div>
	);
}

export function dealTypeSelectorBarItem(component: DealTypeSelectorClass, type: string, value: number | undefined): JSX.Element {
	return (
		<div onClick={ () => component.handleTypeChange(type) }
			class={ clsx([
				styles.dealTypeSelectorItem,
				type === component.type && styles.dealTypeSelectorItemActive,
			]) }
		>
			<div class={ styles.dealTypeSelectorItemTitle }>
				{ component.i18n.t(`dealTypeSelector.${type}`) }
			</div>
			{ value
				? <Button iconFirst={ false } type={ ButtonTypes.link } inverted={ true }
					class={ styles.dealTypeSelectorItemDetails }
					onClick={ () => component.onDetailsClick(type) }
					v-slots={ { icon: () => <Icon name={ IconNames.info } size={ 18 } /> } }>
					{ component.getValueString(type, value) }</Button>
				: <span class={ styles.dealTypeSelectorItemValue }>
					{ component.getValueString(type, value) }</span>
			}
		</div>
	);
}

export function dealTypeSelectorTemplate(component: DealTypeSelectorClass): JSX.Element {
	return (
		<>
			<Transition name="sticky_slide">
				{ <div v-show={ component.sticked || component.staticBar } ref="sticky"
					class={ clsx([
						styles.dealTypeSelectorBar,
						!component.staticBar && styles.dealTypeSelectorBarFixed,
					]) }>
					<Loader show={ component.loading } />
					<div class={ styles.dealTypeSelectorSelector }>
						{ component.values.map(
							({ type, value }) => dealTypeSelectorBarItem(component, type, value)
						) }
					</div>
				</div> }
			</Transition>
			{ !component.staticBar && <div class={ styles.dealTypeSelector }>
				<div class="precise-price-app__container">
					<div class={ styles.dealTypeSelectorTitle }>
						{ component.i18n.t('dealTypeSelector.title') }
					</div>
					<div class={ styles.dealTypeSelectorContainer }>
						<Loader show={ component.loading } />
						<div class={ styles.dealTypeSelectorSelector } ref="element">
							{ component.values.map(
								({ type, value }) => dealTypeSelectorItem(component, type, value)
							) }
						</div>
					</div>
				</div>
			</div> }
		</>
	);
}
